<div class="modal" id="trialPopup">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded-10 border-0">
      <!-- Kingpin Logo on Top -->
      <div class="text-center mt-4 logo-container">
        <img
          src="/assets/img/playstore.png"
          alt="Kingpin Logo"
          width="150"
        />
      </div>

      <!-- Title and new text in stacked format -->
      <div class="modal-header px-0 pt-5 border-0">
        <div class="text-center w-100">
          <h4 class="fw-bold text-dark">Sports Picks Subscription</h4>
          <p class="mt-2">
            Sign up today and follow the picks of these top experts:
          </p>
        </div>
        <!-- X (close) button in the upper-right corner -->
        <button
          type="button"
          class="btn-close"
          (click)="closePopup()"
          aria-label="Close"
        >
          &times; <!-- X symbol -->
        </button>
      </div>

      <!-- Top 3 Users Table -->
      <div class="row mb-3 fw-bold">
        <div class="col-3"></div>
        <!-- No title for profile picture -->
        <div class="col-6">User</div>
        <div class="col-3">Total Winnings</div>
      </div>

      <div *ngIf="topUsers && topUsers.length > 0">
        <div *ngFor="let user of topUsers; let i = index">
          <div class="row mb-3">
            <div class="col-3">
              <img
                [src]="user.user_avatar | baseUrl"
                alt="user"
                class="rounded-circle"
                width="50"
                height="50"
              />
            </div>
            <div class="col-6">
              <strong>#{{ i + 1 }} {{ user.name }}</strong>
            </div>
            <div class="col-3">
              <span
                [class.text-danger]="user.total_winnings < 0"
                [class.text-success]="user.total_winnings > 0"
              >
                {{ user.total_winnings | CustomCurrency }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Countdown Timer right above the Free Trial Button -->
      <!-- This section is only displayed on non-mobile devices -->
      <div class="text-center mt-3" *ngIf="!isMobile">
        <p id="countdown" class="fw-bold"></p>
      </div>

      <!-- Green Free Trial Button -->
      <button
        type="button"
        class="btn btn-success mt-3"
        (click)="startFreeTrial()"
      >
        Click here to Start Your 7-Day FREE Trial
      </button>

      <!-- Link for no thanks option -->
      <div class="mt-3 text-center">
        <a
          class="text-muted"
          href="#"
          (click)="closePopup(); $event.preventDefault()"
          >No thanks, let me continue to the site →</a
        >
      </div>
    </div>
  </div>
</div>
